import React from 'react';
import { Stack, Typography } from '@mui/material';
import { ListTable, Panel, StatusChip, type ListColumn } from '../../../ui-kit';
import { extensionVersion, fetchCwOptions, type CwOptions } from '../../../services/carrierWebsiteService';
import { useLive } from '../rocco/live';

type Carrier = CwOptions['carriers'][number];

/** What this agent is joined to: the extension in this browser, and the carrier websites. */
export default function IntegrationsPage() {
  const { data, loading } = useLive(fetchCwOptions, 15_000);
  const version = extensionVersion();
  const columns: ListColumn<Carrier>[] = [
    { key: 'name', header: 'Carrier website', grow: 1, minWidth: 200,
      render: (c) => <Typography variant="body2" sx={(t) => ({ color: t.tokens.text.primary })}>{c.name}</Typography> },
    { key: 'url', header: 'Address', grow: 1, minWidth: 200,
      render: (c) => <Typography variant="body2" sx={(t) => ({ color: t.tokens.text.secondary, overflowWrap: 'anywhere' })}>{c.url}</Typography> },
    { key: 'guide', header: 'Guide', width: 180,
      render: (c) => <StatusChip tone={c.guide === 'approved' ? 'good' : c.guide ? 'warning' : 'neutral'}
        label={c.guide === 'approved' ? 'Approved' : c.guide ? 'Draft' : 'Not visited yet'} /> },
  ];
  return (
    <Stack spacing={2}>
      <Panel title="Klaris Chrome extension" subtitle="It works in your own browser, on the carrier's website"
        tools={<StatusChip tone={version ? 'good' : 'warning'} label={version ? `Installed · version ${version}` : 'Not in this browser'} />}>
        <Typography variant="body2" sx={(t) => ({ color: t.tokens.text.secondary })}>
          {version
            ? 'Klaris can open a carrier website in a new tab here. It sees only the websites listed below.'
            : 'To add it: open chrome://extensions, turn on Developer mode, choose Load unpacked, and pick the extension folder. Then reload this page.'}
        </Typography>
      </Panel>
      <Panel title="Carrier websites" subtitle="The websites Klaris can open for you">
        <ListTable columns={columns} rows={data?.carriers ?? []} getRowKey={(c) => c.key} loading={loading} emptyMessage="No carrier websites." />
      </Panel>
    </Stack>
  );
}
